module.exports = {"410203001":"清平街道","410203002":"铁塔街道","410203003":"曹门街道","410203004":"宋门街道","410203005":"工业街道","410203006":"苹果园街道","410203200":"东郊乡","410203201":"土柏岗乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410203.json
// module id = 1529
// module chunks = 0